import { render, staticRenderFns } from "./MatterDetails.vue?vue&type=template&id=7970b99e&scoped=true"
import script from "./MatterDetails.vue?vue&type=script&lang=js"
export * from "./MatterDetails.vue?vue&type=script&lang=js"
import style0 from "./MatterDetails.vue?vue&type=style&index=0&id=7970b99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970b99e",
  null
  
)

export default component.exports